import gql from 'graphql-tag';
import { PLANOGRAM_ITEM_PLANOGRAM_DETAIL_FRAGMENT } from './PLANOGRAM_ITEM_PLANOGRAM_DETAIL_FRAGMENT';

export const SWAP_PLANOGRAM_ITEMS = gql`
	mutation swapPlanogramItems (
		$sourceId: ID!,
		$destinationId: ID!,
	) {
		swapPlanogramItems(
			sourceId: $sourceId,
			destinationId: $destinationId,
		) {
			...planogramItemPlanogramDetail
		}
	}
	${PLANOGRAM_ITEM_PLANOGRAM_DETAIL_FRAGMENT}
`;



